import { FC, useEffect, useContext } from 'react';
import { AppContext } from 'provider/AppProvider/AppProvider';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import parse from 'html-react-parser';

interface IFavicon extends HTMLElement {
  href?: string;
}

const DEFAULT_FAVICON_PATH = '/actionera.ico';

const SEOFavicon: FC = () => {
  const { name, setup, title, description } = useContext(AppContext);
  const iconURL: string = setup.icon ?? DEFAULT_FAVICON_PATH;
  const contentTitle = title ? `${title} -- ${name ?? ''}` : name;
  useEffect(() => {
    const favicon: IFavicon = document.getElementById('favicon') as HTMLElement;
    favicon.href = iconURL;
  }, []);

  return (
    <HelmetProvider>
      <Helmet>
        {setup.head_tag ? parse(setup.head_tag) : null}
        <title>{contentTitle}</title>
        <link rel="icon" type="image/png" sizes="96x96" href={iconURL} />
        <link rel="apple-touch-icon" href={iconURL} />
        <meta name="description" content={description} />
      </Helmet>
    </HelmetProvider>
  );
};

export default SEOFavicon;
